import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';
import divisionPersonalServices from './divisionPersonal.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getPersonalDivision = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_PERSONAL_DIVISION,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(iType === 1 ? '/api/app/Formal_Division_Personal/' : '/api/app/Funcional_Division_Personal/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await divisionPersonalServices.getDivisionPersonals(params, iType);
    dispatch({
      type: actions.GET_PERSONAL_DIVISION,
      payload: {
        divisionPersonal: resp.data.data,
        divisionPersonalLength: resp.data.count
      }
    });
    dispatch({
      type: actions.PERSONAL_DIVISION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.PERSONAL_DIVISION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_PERSONAL_DIVISION,
      payload: false
    });
  }
}

export const savePersonalDivision = (req, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_PERSONAL_DIVISION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_Division_Personal/' : '/api/app/Funcional_Division_Personal/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await divisionPersonalServices.saveDivisionPersonal(req, iType);
    const { divisionPersonal, divisionPersonalLength } = getState().divisionPersonal;
    const aDivisionPersonal = [...divisionPersonal, resp.data];
    dispatch({
      type: actions.GET_PERSONAL_DIVISION,
      payload: {
        divisionPersonal: aDivisionPersonal,
        divisionPersonalLength: divisionPersonalLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_PERSONAL_DIVISION,
      payload: false
    });
  }
}

export const editPersonalDivision = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_PERSONAL_DIVISION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Division_Personal/${id}/` : `/api/app/Funcional_Division_Personal/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await divisionPersonalServices.editDivisionPersonal(id, req, iType);
    const { divisionPersonal, divisionPersonalLength } = getState().divisionPersonal;
    divisionPersonal[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_PERSONAL_DIVISION,
      payload: {
        divisionPersonal: divisionPersonal,
        divisionPersonalLength: divisionPersonalLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_PERSONAL_DIVISION,
      payload: false
    });
  }
}

export const deletePersonalDivision = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_PERSONAL_DIVISION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 1 ? `/api/app/Formal_Division_Personal/${id}/` : `/api/app/Funcional_Division_Personal/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await divisionPersonalServices.deleteDivisionPersonal(id, iType)
    const { divisionPersonal, divisionPersonalLength } = getState().divisionPersonal;
    divisionPersonal.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_PERSONAL_DIVISION,
      payload: {
        divisionPersonal: divisionPersonal,
        divisionPersonalLength: divisionPersonalLength -1
      }
    });
    dispatch({
      type: actions.PERSONAL_DIVISION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.PERSONAL_DIVISION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_PERSONAL_DIVISION,
      payload: false
    });
  }
}
